import { useAuth0 } from "@auth0/auth0-react";
import { ReactComponent as Close } from "assets/icons/close.svg";
import BottomArrowSvg from "assets/icons/svg/BottomArrowSvg";
import { InputField, LabelField, MyCheckbox } from "components";
import { useSearch } from "hook";
import React, { createContext, useContext, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import DatePicker from "react-datepicker";
import { toastr } from "react-redux-toastr";
import Select, { components } from "react-select-v2";
import MaskedInput from "react-text-mask";
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";
import FinanceService from "../../../Lib/API/Finance";
import { CheckFloatValue, getOrganizationInfoFromLocalStorage } from "../../../utils/functions";
import UserContext from "../NewChargeContext";
import FinanceAccordion from "./Accordion";

import AlertDialog from "components/Dialog/index";
import MyModal from "components/MyModal";
import { getDateFormat, getDateFormatForDatePicket, maskDate } from "helper/dateFormat";
import { getCurrency, numberFormat } from "helper/numberFormat";
import AddNewAccount from "pages/Members/AddNewAccount";
import Spinner from "components/spinner";
import { getRandColor } from "utils/emailRandomColors";
import {
  ACH,
  ACHHeader,
  Cash,
  CashHeader,
  Check,
  CheckHeader,
  CreditCard,
  CreditCardHeader,
  CreditOnAccount,
  CreditOnAccountHeader,
  NewPaymentMethod,
  NewPaymentMethodHeader,
} from "./PaymentMethods";
import { fontConfig } from "theme/fontConfig";

const PaymentInformation = ({ index, ...props }) => {
  const orgDetails = getOrganizationInfoFromLocalStorage();

  const [expandVIew, setExpandView] = useState("");
  const [loading, setLoading] = React.useState(false);
  const [search, setSearch] = useState("");
  const { searchAction } = useSearch({ action: setSearch });
  const [data, setData] = useState();
  const [expanded, setExpanded] = useState(null);
  const [selectedMethodIndices, setSelectedMethodIndices] = useState([]);
  const { getAccessTokenSilently, user: auth0User } = useAuth0();
  const [createNewAccount, setCreateNewAccount] = useState(false);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [paymentMethodsLoading, setPaymentMethodsLoading] = useState(true);
  const [lastUsedMethodTypes, setLastUsedMethodTypes] = useState([]);
  const [current, setCurrent] = useState([]);
  const [paymentMethodTitle, setPaymentMethodTitle] = useState("");
  const [selected, setSelected] = useState(null);
  const [selectedAch, setSelectedAch] = useState("");
  const [payNowSelectedRow, setPayNowSelectedRow] = useState("");
  const [createNewAccountLoading, setCreateNewAccountLoading] = useState(false);
  const [createNewAccountModal, setCreateNewAccountModal] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [confirmClose, setConfirmClose] = useState(false);
  const [creditOnAccountBalance, setCreditOnAccountBalance] = useState(null);
  const dateTimeMask = maskDate();
  const currency = getCurrency();
  const placeholderFormat = getDateFormat();
  const dateFormate = getDateFormatForDatePicket();


  const { hfinish, setHFinish } = useContext(UserContext);
  const autoCorrectedDatePipe = createAutoCorrectedDatePipe(dateFormate || "mm/dd/yyyy");

  function convertUTCToLocalDate(date) {
    if (!date) {
      return date;
    }
    date = new Date(date);
    date = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
    return date;
  }

  function convertLocalToUTCDate(date, name) {
    if (!date) {
      return date;
    }
    date = new Date(date);
    date = new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
    );
    formik.setFieldValue(name, date);
    return date;
  }
 
  useEffect(() => {
    const selectedTitles = selectedMethodIndices.map(i => paymentMethods[i]?.title).filter(Boolean);
    formik.setFieldValue("_selectedPaymentMethodTitles", selectedTitles);
  // eslint-disable-next-line
  }, [selectedMethodIndices, paymentMethods]);

  useEffect(() => {
    const account = formik?.values?.accountInfo;
    const defaultEmails = account?._id ? account?.defaultEmails || [] : formik?.values?.allData?.length > 0 ? formik?.values?.allData?.[0]?.Account?.defaultEmails : formik?.values?.account_name?.defaultEmails ?? [];
    if (!defaultEmails?.length) return;
    const updatedEmails = defaultEmails.map((item) => {
      return {
        type: "to",
        email: item,
        image: item.charAt(0).toUpperCase(),
        color: getRandColor(),
      };
    });
    formik.setFieldValue("emailsReceipt", updatedEmails);
    if(orgDetails?.sendReceiptOnPayment) {
      formik.setFieldValue("emailOnReceipt", true);
    }
  }, [formik?.values?.accountInfo]);

  useEffect(() => {
    const selected = localStorage.getItem("payNowItem")
      ? JSON.parse(localStorage.getItem("payNowItem"))
      : "";
    setPayNowSelectedRow(selected);
    if (selected) {
      formik.setFieldValue("actual_total", formik.values?.amount_due);
    }
    localStorage.removeItem("payNowItem");
  }, []);

  useEffect(() => {
    if(!selectedAch && (!selected || Object?.keys(selected || {})?.length === 0)) {
      formik.setFieldValue("selectedUpdatedPayData","");
      formik.setFieldValue("selectedUpdatePayDataMethod","");
      return;
    }
    if(selected && Object?.keys(selected || {})?.length && !selectedAch) {
      setSelectedAch("");
    }
    if (formik?.values?.values?.[0]?.isRecurring) {
      formik.setFieldValue(
        "selectedUpdatedPayData",
        selectedAch === "" ? selected?.id : selectedAch.id
      );
      formik.setFieldValue(
        "selectedUpdatePayDataMethod",
        selectedAch === "" ? "credit_card" : "ach"
        );
      }
  }, [selectedAch, selected]);

  const enableLoading = (value) => {
    setLoading(value);
  };
  const selectControlStyles = {
    backgroundColor: "#F3F6F9",
    borderColor: "#F3F6F9",
    color: "#3F4254",
    transition:
      "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
    paddingTop: "6px",
    paddingBottom: "6px",
    cursor: "pointer",
  };
  const colourStyles = {
    control: (styles) => ({
      ...styles,
      ...selectControlStyles,
    }),
    menuList: (styles) => ({
      ...styles,
      maxHeight: "280px",
    }),
    menu: (styles) => ({
      ...styles,
      zIndex: 9999,
    }),
  };
  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <BottomArrowSvg label="Emoji" />
      </components.DropdownIndicator>
    );
  };
  const formatOptionLabel = ({ label, account_id }, e) => {
    return (
      <div className="dropdown-container" key={account_id}>
        <div className="icon-name-container d-flex align-items-center justify-content-start">
          <div className="name-container" style={{ marginInlineStart: 10 }}>
            <div>{label}</div>
          </div>
        </div>
      </div>
    );
  };


  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const formik = props;

  // Fetch the Credit On Account wallet balance so the payment method
  // pill can be greyed out when it's 0.
  useEffect(() => {
    const accountId = formik?.values?.account_name?.id ?? formik?.values?.accountIds;
    if (!accountId) {
      setCreditOnAccountBalance(null);
      return;
    }
    let cancelled = false;
    (async () => {
      const token = await getAccessTokenSilently();
      await FinanceService.getCreditOnAccountAmount(accountId, token)
        .then((res) => {
          if (!cancelled) setCreditOnAccountBalance(res?.result?.balance ?? 0);
        })
        .catch(() => {
          if (!cancelled) setCreditOnAccountBalance(null);
        });
    })();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line
  }, [formik?.values?.account_name?.id, formik?.values?.accountIds]);

  // Load payment history for the logged-in admin on mount
  useEffect(() => {
    const adminKey = auth0User?.sub || auth0User?.email;
    if (!adminKey) return;
    try {
      const stored = localStorage.getItem(`admin_payment_history_${adminKey}`);
      if (stored) setLastUsedMethodTypes(JSON.parse(stored));
    } catch (_) {}
  }, [auth0User]);

  useEffect(() => {
    formik.setFieldValue("selectedPaymentTitles", current);
  }, [current]);

  const sumOfAmounts = formik.values?.allData?.reduce((a, b) => {
    return Number(a) + Number(b?.charge?.amount);
  }, 0);

  const setMethods = {
    check: {
      content: <Check formik={formik} title="check" />,
      header: <CheckHeader formik={formik} />,
    },
    "credit card": {
      content: <CreditCard formik={formik} enablePaymentInstallments={!formik?.values?.allData && orgDetails?.allowInstallments && formik?.values?.values?.length === 1}  />,
      header: <CreditCardHeader formik={formik} />,
    },
    ach: {
      content: <ACH formik={formik} enablePaymentInstallments={!formik?.values?.allData && orgDetails?.allowInstallments && formik?.values?.values?.length === 1}/>,
      header: <ACHHeader formik={formik} />,
    },
    cash: {
      content: <Cash formik={formik} />,
      header: <CashHeader formik={formik} />,
    },
    "credit on account": {
      content: <CreditOnAccount formik={formik} />,
      header: <CreditOnAccountHeader formik={formik} />,
    },
    default: {
      content: <NewPaymentMethod formik={formik} />,
      header: (
        <NewPaymentMethodHeader
          formik={formik}
          setPaymentMethodTitle={setPaymentMethodTitle}
        />
      ),
    },
  };

  const setMethodsForRecurring = {
    "credit card": {
      content: <CreditCard formik={formik} enableInstallments={false}/>,
      header: <CreditCardHeader formik={formik} />,
    },
    ach: {
      content: <ACH formik={formik} enableInstallments={false}/>,
      header: <ACHHeader formik={formik} />,
    },
  };

  const fetchMyAPI = async () => {
    enableLoading(true);
    const token = await getAccessTokenSilently();
    await FinanceService.getACcountNames(token, search)
      .then((res) => {
        if (res?.accounts) {
          res.accounts.map((item) => {
            item.label = item.family_name;
            item.value = item.account_id;
            return item;
          });
          setData(res?.accounts);
        }
        enableLoading(false);
      })
      .catch((error) => {
        toastr.error("Error", error?.data?.message);
      });
  };
  useEffect(() => {
    fetchMyAPI();
  }, [search, getAccessTokenSilently, refresh]);

  useEffect(() => {
    const getMethods = async () => {
      setPaymentMethodsLoading(true);
      const token = await getAccessTokenSilently();
      const methods = await FinanceService.getPaymentMethods(token);
      setPaymentMethodsLoading(false);
      setPaymentMethods(
        methods.result
          .map((item) => {
            // the Cash method can come back as "cash" or "Cash"; both must use the Cash
            // component (bound to cash_payment), not the custom-method input
            const methodKey = item.type?.toLowerCase() === "cash" ? "cash" : item.type;
            const findMethod = formik?.values?.values?.[0]?.isRecurring
              ? setMethodsForRecurring[methodKey]
              : setMethods[methodKey];

            if (formik?.values?.values?.[0]?.isRecurring) {
              return {
                title: item.type,
                is_default: item.is_default,
                coverConvenienceFee: item.coverConvenienceFee,
                convenienceFeeInfo: item.convenienceFeeInfo,
                allowInstallment: item.allowInstallment,
                paymentGateway: item?.paymentGateway || {},
                type: item.type,
                _id: item._id,
                ...findMethod,
              };
            } else if (
              !formik?.values?.values?.[0]?.isRecurring &&
              findMethod
            ) {
              return {
                title: item.type,
                is_default: item.is_default,
                coverConvenienceFee: item.coverConvenienceFee,
                convenienceFeeInfo: item.convenienceFeeInfo,
                allowInstallment: item.allowInstallment,
                paymentGateway: item?.paymentGateway || {},
                type: item.type,
                _id: item._id,
                ...findMethod,
              };
            } else {
              return {
                ...setMethods["default"],
                      content: (

              <NewPaymentMethod

                formik={formik}

                paymentType={item.type}

                paymentMethodId={item._id}

              />),
                ...item,
                title: item.type,
                nonExpandable: true,
              };
            }
          })
          .filter((item) => item !== undefined)
      );
    };
    getMethods();
  }, [getAccessTokenSilently]);
  useEffect(() => {
    if(!paymentMethods?.length) return;
    formik.setFieldValue("allPaymentsMethods", paymentMethods);
    // Restore selected method indices and current from formik on remount
    const savedIndices = formik.values?._selectedMethodIndices;
    const savedCurrent = formik.values?._selectedMethodCurrent;
    if (savedIndices?.length) {
      setSelectedMethodIndices(savedIndices);
      setExpanded(savedIndices[savedIndices.length - 1]);
    }
    if (savedCurrent?.length) {
      setCurrent(savedCurrent);
    }
  }, [paymentMethods]);

  useEffect(() => {
    if (!paymentMethods?.length) return;
    formik.setFieldValue("_selectedMethodIndices", selectedMethodIndices);
  }, [selectedMethodIndices]);

  useEffect(() => {
    if (!paymentMethods?.length) return;
    formik.setFieldValue("_selectedMethodCurrent", current);
  }, [current]);

  const calculateConvenienceFeeAmount = () => {
    const values = formik?.values;
    let paymentMethods = [];
    if(formik?.values?.values?.[0]?.isRecurring) {
      paymentMethods = calculationIsRecurringPaymentsMethods(values);
    } else {
      paymentMethods = calculationPaymentsMethods(values);
    }
    let amount = 0;
    const convenienceFee = paymentMethods?.map((item) => {
      if(item?.amount && item?.amount > 0) {
      const paymentMethod = values?.allPaymentsMethods?.find(
        (method) => (method?.type?.toLowerCase() === item?.paymentMethod?.toLowerCase() || (method?.type === "credit on account" && item?.paymentMethod === "credit_on_account") || (
          method?.type === "credit card" && item?.paymentMethod === "credit_card"
        ))
      );
        // if (paymentMethod?.coverConvenienceFee) {     
           if (!paymentMethod?.coverConvenienceFee) return;

         const optionalKey = `${paymentMethod?._id}`;

         if (values?.[optionalKey] === false) return;
          amount += paymentMethod?.convenienceFeeInfo?.type === "%" ? (item?.amount * paymentMethod?.convenienceFeeInfo?.amount) / 100 : paymentMethod?.convenienceFeeInfo?.amount;
        // } 
      }
    })
    
    const checksHasAmount = values?.checks?.some((item) => parseFloat(item.amount) > 0)
    if(checksHasAmount) {
      const paymentMethod = values?.allPaymentsMethods.find(
        (method) => method.type === "check"
      );
      const amounts = values?.checks?.reduce(
        (total, item) => total + parseFloat(item.amount || 0),
        0
      );
      // if(paymentMethod?.coverConvenienceFee) {
       if (!paymentMethod?.coverConvenienceFee) return amount;

          const optionalKey = `${paymentMethod?._id}`;

         if (values?.[optionalKey] === false) return amount;
        amount += paymentMethod?.convenienceFeeInfo?.type === "%" ? (amounts * paymentMethod?.convenienceFeeInfo?.amount) / 100 : paymentMethod?.convenienceFeeInfo?.amount;
      // }
    }
    return amount;
  }

  const calculationIsRecurringPaymentsMethods = (values) => {
    let filterPaymentMethods = [];
      const paymentsMethods = paymentMethods?.map((item) => {
      if((values?.selectedUpdatePayDataMethod === item?.type || (values?.selectedUpdatePayDataMethod === "credit_card" && (item?.type === "credit_card" || item?.type === "credit card")))) {
        filterPaymentMethods.push({
          ...item,
          amount: isNaN(formik.values?.actual_total) ? 0 : formik.values?.actual_total,
          paymentMethod: (item?.type === "credit card" || item?.type === "credit_card") ? "credit_card" : item?.type,
        })
      }
    });
    return filterPaymentMethods;
  }
  const calculationPaymentsMethods = (values) =>{
    const paymentMethods = Object.entries(values)
    .filter(([key]) => key.includes("_payment"))
    .map(([key, value]) => {
      const split = key.split("_payment");
      if (
        split[0].includes("credit") &&
        parseFloat(values.creditCardAmount)
      ) {
        return {
          ...value,
          paymentMethod:
            split[0] === "credit card" ? "credit_card" : split[0],
          amount: values?.creditCardAmount,
          cardId: values?.cardDetail?.id ?? values?.SelectedProviderId,
          /* cvc: values.cvc */
        };
      }
      if (split[0].includes("ach") && parseFloat(values.ach)) {
        return {
          paymentMethod: "ACH",
          amount: values?.ach,
          achId: values?.payments?.[0]?.ACH,
        };
      }
      if (split[0].includes("cash") && parseFloat(values.cash_payment) > 0) {
        return {
          paymentMethod: split[0] === "cash" ? "cash" : split[0],
          amount: values.cash_payment,
        };
      }
      if (
        split[0].includes("onAccountCredit") &&
        parseFloat(values?.onAccountCredit_payment)
      ) {
        return {
          paymentMethod:
            split[0] === "onAccountCredit" ? "credit_on_account" : split[0],
          amount: values?.onAccountCredit_payment,
        };
      }
      if (parseFloat(value) > 0) {
        return { amount: value, paymentMethod: split[0] };
      }
      return;
    })
    .filter((item) => item !== undefined);
    return paymentMethods;    
  }
  

  const onPaymentValueChange = (id, event) => {
    const { value, name } = event.target;
    const paymentKey = `${id}_payment`;
    formik.setFieldValue(paymentKey, {
      ...formik.values[paymentKey],
      [name]: value,
    });
    const numberValue = name === "amount" ? +value : value;
    const paymentObject = formik.values?.payments?.find(
      (item) => item.paymentMethod === id
    );
    if (paymentObject) {
      const index = formik.values?.payments?.findIndex(
        (item) => item.paymentMethod === id
      );
      if (index !== -1) {
        formik.setFieldValue("payments", [
          ...formik.values?.payments?.splice(index, 1),
          {
            ...formik.values?.payments?.[index],
            paymentMethod: id,
            [name]: numberValue,
          },
        ]);
      }
    } else {
      if (formik.values?.payments) {
        formik.setFieldValue("payments", [
          ...formik.values?.payments,
          { paymentMethod: id, [name]: numberValue },
        ]);
      }
      formik.setFieldValue("payments", [
        { paymentMethod: id, [name]: numberValue },
      ]);
    }
    const paymentName =
      paymentMethods.find((item) => item.title === id)?.title ?? "N/A";
    const paymentNameIndex = formik.values?.paymentMethods?.findIndex(
      (item) => item.name === paymentName
    );
    if (paymentNameIndex === -1) {
      formik.setFieldValue("paymentMethods", [
        ...(formik.values?.paymentMethods ?? []),
        {
          name: paymentName,
          [name]: numberValue,
        },
      ]);
    } else {
      formik.setFieldValue("paymentMethods", [
        ...(formik.values?.paymentMethods?.splice(paymentNameIndex, 1) ?? []),
        {
          name: paymentName,
          [name]: numberValue,
        },
      ]);
    }
  };
  const regex = /([0-9]*[\.|\,]{0,1}[0-9]{0,2})/s;

  const methods = Object.entries(formik?.values)
    .filter(
      ([key]) =>
        key.includes("_payment") &&
        key !== "onAccountCredit_payment" &&
        key !== "cash_payment" &&
        key !== "ach_payment" &&
        !key.includes("credit") &&
        !key.includes("ach") &&
        !key.includes("cash")
    )
    .map(([key, value]) => {
      const split = key.split("_payment");
      return {
        paymentMethod: split[0],
        amount: isNaN(formik?.values?.[key])
          ? 0
          : formik?.values?.[key] === ""
          ? 0
          : formik?.values?.[key],
      };
    })
    .filter((item) => item !== undefined);

  const newPaymentMethod = paymentMethodTitle;
  const totalValue =
    formik.values?.checks &&
    formik.values?.checks?.reduce(function (pre, curr) {
      return Number(pre) + Number(curr.amount);
    }, 0);
  const totalPayment = [];
  if (formik?.values?.cash_payment) {
    totalPayment.push(Number(formik?.values?.cash_payment));
  }
  if (formik.values?.checks) {
    totalPayment.push(Number(totalValue));
  }
  if (formik?.values?.onAccountCredit_payment) {
    totalPayment.push(Number(formik?.values?.onAccountCredit_payment));
  }
  if (formik?.values?.creditCardAmount) {
    totalPayment.push(Number(formik?.values?.creditCardAmount));
  }
  if (formik?.values?.ach) {
    totalPayment.push(Number(formik?.values?.ach));
  }

  const paymentValues =
    methods && methods?.map((item) => parseFloat(item?.amount));
  const newPaymentsValues = paymentValues.filter(function (value) {
    return !Number.isNaN(value);
  });

  const sumofNewPayments = newPaymentsValues?.reduce((sum, a) => sum + a, 0);
  const sumofPayments = totalPayment?.reduce(
    (partialSum, a) => (isNaN(partialSum) ? 0 : Number(partialSum)) + Number(a),
    0
  );
  const totalSumofValues = methods?.length
    ? +sumofNewPayments + sumofPayments
    : sumofPayments;


  const totalSplittedAmount =
    formik?.values?.allData &&
    formik?.values?.allData?.map((item) => item?.Charges?.amount_due);
  const sumOfSplittedAmount = totalSplittedAmount?.reduce(
    (partialSum, a) => Number(partialSum) + Number(a),
    0
  );
  const [calculatedAmount, setCalculatedAmount] = useState("00");
  let commingAmount =
    formik.values?.amount_due === 0 || formik.values?.amount_due
      ? formik.values?.amount_due
      : formik.values?.values?.[0]?.split_amount
      ? formik.values?.values?.[0]?.split_amount
      : formik.values?.values?.[0]?.total_amount ?? sumOfAmounts;

  useEffect(() => {
    let finalDiscount =
      formik?.values?.values?.[0]?.discount_type == "%"
        ? (formik?.values?.values?.[0]?.discount / 100) * commingAmount
        : // .replace("-", "")
          formik?.values?.values?.[0]?.discount;
    let finalTax =
      formik?.values?.values?.[0]?.tax_type == "%"
        ? (formik?.values?.values?.[0]?.tax / 100) * commingAmount
        : // .replace("-", "")
          formik?.values?.values?.[0]?.tax;

    let finalAmount = numberFormat({number:(
      (formik?.values?.values?.[0]?.discount ? Number(finalDiscount) : 0) +
      -(
        commingAmount +
        (formik?.values?.values?.[0]?.tax ? Number(finalTax) : 0)
      )
    ), decimal:2, style: "decimal"})
      .replace("-", "");

    setCalculatedAmount(finalAmount);
  }, [formik.values]);

  const getCommaSeperatedValue = (num) => {
    return CheckFloatValue(parseFloat(num))
      ?.toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const chargePaid = formik.values?.values?.[0]?.is_splitted
    ? formik.values?.actual_total
    : Number(formik.values?.values?.[0]?.total_amount) -
      formik.values?.values?.[0]?.charge?.paid;


    const calculateTotalPaidAmount = () => {
      return formik.values?.values?.[0]?.isRecurring
      ? isNaN(formik.values?.actual_total)
        ? "0"
        : +formik.values?.actual_total
      : isNaN(totalSumofValues)
      ? "0"
      : +totalSumofValues
    }

    const calculateTotalAmount = () => {
      return (formik.values?.type === "edit-charge" && formik.values?.values?.[0]?.charge?.paid) 
        ? +formik.values?.actual_total - +formik.values?.values?.[0]?.charge?.paid
        : formik.values?.values?.[0]?.charge?.paid === 0
          ? +formik.values?.actual_total
          : formik.values?.values?.[0]?.charge?.paid
          ? +chargePaid
          : formik.values?.type === "edit-charge"
          ?+formik.values?.actual_total
          : formik.values?.amount_due === 0 || formik.values?.amount_due
          ? +formik.values?.amount_due
          : formik?.values?.allData?.[0]?.charge?.amount
          ? +sumOfSplittedAmount
          : formik?.values?.values?.[0]?.split_amount
          ? +formik?.values?.values?.[0]?.split_amount
          : formik?.values?.actual_total
          ? +formik.values?.actual_total
          : formik.values?.current_total
          ? +formik.values?.current_total
          : formik.values?.current_amount
          ? +formik.values?.current_amount
          : formik.values?.values?.[0]?.split_amount
          ? +formik.values?.values?.[0]?.split_amount
          : +formik.values?.values?.[0]?.total_amount
          ?? +sumOfAmounts
    }
              
    const disabledPaymentDate = () => {
      if(formik?.values?.values?.[0]?.isRecurring) {
        return formik?.values?.selectedUpdatePayDataMethod === "credit_card"
      }
      return formik?.values?.["credit card_payment"] && (formik?.values?.cardDetail?.id ?? formik?.values?.SelectedProviderId) && formik?.values?.creditCardAmount;
    }

    const openCreateNewAccount = () => {
      setCreateNewAccountModal(true);
    }

    const closeCreateNewAccount = () => {
      setConfirmClose(true);
    }
    const confirmCloseHandler = () => {
      setCreateNewAccountModal(false);
      setConfirmClose(false);
    }

    const isCreditOnAccountEmpty = (method) => {
      return method?.type?.toLowerCase() === "credit on account"
        && creditOnAccountBalance !== null
        && parseFloat(creditOnAccountBalance) <= 0;
    };

    const deselectPaymentMethod = (method, index) => {
      const t = method?.type?.toLowerCase();
      setSelectedMethodIndices(prev => prev.filter(i => i !== index));
      if (expanded === index) setExpanded(null);
      if (t === "credit card" || t === "credit_card") {
        formik.setFieldValue("cc_future_enabled", false);
        formik.setFieldValue("cc_future_date", null);
        formik.setFieldValue("creditCardAmount", "");
        formik.setFieldValue("credit card_payment", "");
        // Also clear Credit Card's own installment flag so it stops blocking
        // ACH's "Pay in Installments"/"Future Payment" checkboxes once
        // Credit Card is no longer a selected payment method.
        formik.setFieldValue("allowCreditInstallment", false);
        formik.setFieldValue("installmentCreditDetails", { cycle: "", frequency: "", startInstallment: new Date() });
      } else if (t === "ach") {
        formik.setFieldValue("ach_future_enabled", false);
        formik.setFieldValue("ach_future_date", null);
        formik.setFieldValue("ach", "");
        // Same as above, but for ACH's own installment flag.
        formik.setFieldValue("allowAchInstallment", false);
        formik.setFieldValue("installmentAchDetails", { cycle: "", frequency: "", startInstallment: new Date() });
      } else if (t === "check") {
        formik.setFieldValue("checks", []);
      } else if (t === "cash") {
        formik.setFieldValue("cash_payment", "");
      } else if (t === "credit on account") {
        formik.setFieldValue("onAccountCredit_payment", "");
      } else {
        formik.setFieldValue(`${method?.title}_payment`, "");
      }
    };

    // Recurring charges only ever bill a single payment method going forward
    // (matches main-2026: one `selectedUpdatePayDataMethod` + one `actual_total`),
    // so picking a new method for a recurring charge replaces the previous one
    // instead of adding to a multi-select like the non-recurring flow.
    const selectPaymentMethod = (method, index) => {
      const isRecurringCharge = formik?.values?.values?.[0]?.isRecurring;
      if (isRecurringCharge) {
        selectedMethodIndices
          .filter(i => i !== index)
          .forEach(prevIndex => deselectPaymentMethod(paymentMethods[prevIndex], prevIndex));
        setSelectedMethodIndices([index]);
      } else {
        setSelectedMethodIndices(prev => [...prev, index]);
      }
      setExpanded(index);
      setCurrent(prev => prev.includes(method?.title) ? prev : [...prev, method?.title]);
      if (isRecurringCharge || selectedMethodIndices.length === 0) {
        const total = calculateTotalAmount();
        const t = method?.type?.toLowerCase();
        if (t === "credit card" || t === "credit_card") {
          formik.setFieldValue("creditCardAmount", total);
          formik.setFieldValue("credit card_payment", total);
        } else if (t === "cash") {
          formik.setFieldValue("cash_payment", total);
        } else if (t === "ach") {
          formik.setFieldValue("ach", total);
        } else if (t === "check") {
          const existingCheck = {
            amount: "",
            check_date: "",
            check_number: "",
            paymentMethod: method?.title,
            ...formik.values.checks?.[0],
          };
          formik.setFieldValue("checks", [{ ...existingCheck, amount: total }]);
        } else if (t === "credit on account") {
          formik.setFieldValue("onAccountCredit_payment", total);
        } else {
          formik.setFieldValue(`${method?.title}_payment`, total);
        }
      }
    };

  if (paymentMethodsLoading) {
    return (
      <div className="payment-main" style={{ margin: "0px 24px", minHeight: 400 }}>
        <Spinner />
      </div>
    );
  }

  return (
    <div className="payment-main" style={{ margin: "0px 24px" }}>
      <div className="payment-step2-layout">

        {/* ── LEFT: Payment method selector ─────────────── */}
        <div className="payment-methods-col">
          {/* Recently Used section */}
          {lastUsedMethodTypes.length > 0 && (() => {
            const recentMethods = lastUsedMethodTypes
              .map(type => paymentMethods.find(m => m.type?.toLowerCase() === type || m.title?.toLowerCase() === type))
              .filter(Boolean)
              .filter(method => method?.header && method?.content);
            if (!recentMethods.length) return null;
            return (
              <div className="pm-recently-used">
                <div className="pm-recently-used__label">Recently Used</div>
                <div className="pm-pill-row pm-pill-row--recent">
                  {recentMethods.map((method) => {
                    const index = paymentMethods.indexOf(method);
                    const isSelected = selectedMethodIndices.includes(index);
                    const isDisabled = isCreditOnAccountEmpty(method);
                    return (
                      <div key={`recent-${index}`} className="pm-method-card-wrapper">
                        <button
                          type="button"
                          className={`pm-method-card pm-method-card--recent-item${isSelected ? " pm-method-card--active" : ""}${isDisabled && !isSelected ? " pm-method-card--disabled" : ""}`}
                          onClick={() => {
                            if (isSelected) {
                              deselectPaymentMethod(method, index);
                              return;
                            }
                            if (isDisabled) {
                              toastr.info("Credit On Account", "Wallet balance is 0");
                            }
                            selectPaymentMethod(method, index);
                          }}
                        >
                          <span className="pm-method-name">{method?.title}</span>
                          {isSelected && (
                            <span
                              className="pm-method-remove"
                              role="button"
                              aria-label={`Remove ${method?.title}`}
                              onClick={(e) => {
                                e.stopPropagation();
                                deselectPaymentMethod(method, index);
                              }}
                            >
                              <Close />
                            </span>
                          )}
                        </button>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })()}

          {/* Method card selector */}
          <div className="pm-recently-used__label" style={{ marginBottom: 8 }}>{lastUsedMethodTypes.length > 0 ? "Additional Payment Methods" : "Payment Method"}</div>
          <div className="pm-pill-row">
            {paymentMethods.map((method) => {
              const index = paymentMethods.indexOf(method);
              const isRecentlyUsed = lastUsedMethodTypes.includes(method?.type?.toLowerCase()) || lastUsedMethodTypes.includes(method?.title?.toLowerCase());
              if (!method?.header && !method?.content) return null;
              if (isRecentlyUsed) return null;
              const isSelected = selectedMethodIndices.includes(index);
              const typeKey = method?.type?.toLowerCase();
              const filledAmount = (() => {
                const v = formik.values;
                if (typeKey === "cash") return parseFloat(v?.cash_payment) > 0 ? v.cash_payment : null;
                if (typeKey === "ach") return parseFloat(v?.ach) > 0 ? v.ach : null;
                if (typeKey === "check") return v?.checks?.some(c => parseFloat(c.amount) > 0) ? v.checks.reduce((s, c) => s + parseFloat(c.amount || 0), 0) : null;
                if (typeKey === "credit card" || typeKey === "credit_card") return parseFloat(v?.creditCardAmount) > 0 ? v.creditCardAmount : null;
                if (typeKey === "credit on account") return parseFloat(v?.onAccountCredit_payment) > 0 ? v.onAccountCredit_payment : null;
                // custom/external payment methods
                const customKey = `${method?.title}_payment`;
                return parseFloat(v?.[customKey]) > 0 ? v[customKey] : null;
              })();
              const hasFilled = filledAmount !== null;
              const isDisabled = isCreditOnAccountEmpty(method);
              return (
                <div key={index} className="pm-method-card-wrapper">
                  <button
                    type="button"
                    className={`pm-method-card${isSelected ? " pm-method-card--active" : ""}${hasFilled ? " pm-method-card--filled" : ""}${isDisabled && !isSelected ? " pm-method-card--disabled" : ""}`}
                    onClick={() => {
                      if (isSelected) {
                        deselectPaymentMethod(method, index);
                      } else {
                        if (isDisabled) {
                          toastr.info("Credit On Account", "Wallet balance is 0");
                        }
                        selectPaymentMethod(method, index);
                      }
                    }}
                  >
                    <span className="pm-method-name">{method?.title}</span>
                    {isSelected && hasFilled && (
                      <span className="pm-method-badge">
                        {currency}{numberFormat({ number: +filledAmount, decimal: 2, style: "decimal" })}
                      </span>
                    )}
                    {isSelected && (
                      <span
                        className="pm-method-remove"
                        role="button"
                        aria-label={`Remove ${method?.title}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          deselectPaymentMethod(method, index);
                        }}
                      >
                        <Close />
                      </span>
                    )}
                  </button>
                </div>
              );
            })}
          </div>

          {/* Expanded content panels for all selected methods */}
          {selectedMethodIndices.map((idx) => {
            const method = paymentMethods[idx];
            if (!method?.header || !method?.content) return null;
            return (
              <div key={idx} className="pm-panel">
                <div className="cash-accordian">
                  <FinanceAccordion
                    selected={selected}
                    setSelected={setSelected}
                    selectedAch={selectedAch}
                    setSelectedAch={setSelectedAch}
                    body={method.content}
                    header={method.header}
                    title={method?.title}
                    type={method?.type}
                    allowPaymentInstallment={method?.allowInstallment}
                    paymentGateway={method?.paymentGateway}
                    expanded={expanded === idx}
                    onChange={handleChange(idx)}
                    onPaymentValueChange={onPaymentValueChange}
                    id={method.id}
                    formik={formik}
                    current={current}
                    setCurrent={setCurrent}
                    setExpanded={setExpanded}
                    index={idx}
                    calculateTotalPaidAmount={calculateTotalPaidAmount}
                    calculateTotalAmount={calculateTotalAmount}
                  />
                </div>
              </div>
            );
          })}
        </div>

        {/* ── RIGHT: Summary sidebar ───────────────────── */}
        {formik?.values?.values?.[0]?.charge?.payment?.status !== "declined" && (
        <div className="payment-information payment-summary-col">
          <div className="payment-info-card">
            <div className="payment-info-total-row">
              <div className="payment-info-total-label">Payment Total</div>
              <div className="payment-info-total-amount">
                <span className="total_payment_amount">
                  {currency}
                  {formik.values?.values?.[0]?.isRecurring
                    ? isNaN(formik.values?.actual_total)
                      ? "0.00"
                      : numberFormat({number:+formik.values?.actual_total, decimal:2, style: "decimal"})
                    : isNaN(totalSumofValues)
                    ? "0.00"
                    : numberFormat({number:+totalSumofValues, decimal:2, style: "decimal"})}
                </span>
                <span className="payment-info-total-divider"> / </span>
                <span className="payment-info-total-due">
                  {currency}
                  {(formik.values?.type === "edit-charge" && formik.values?.values?.[0]?.charge?.paid)
                  ? numberFormat({number:(+formik.values?.actual_total - +formik.values?.values?.[0]?.charge?.paid), decimal:2, style: "decimal"})
                  : formik.values?.values?.[0]?.charge?.paid === 0
                    ? numberFormat({number:+formik.values?.actual_total, decimal:2, style: "decimal"})
                    : formik.values?.values?.[0]?.charge?.paid
                    ? numberFormat({number:+chargePaid, decimal:2, style: "decimal"})
                    : formik.values?.type === "edit-charge"
                    ? numberFormat({number:(+formik.values?.actual_total), decimal:2, style: "decimal"})
                    : formik.values?.amount_due === 0 || formik.values?.amount_due
                    ? numberFormat({number:(+formik.values?.amount_due), decimal:2, style: "decimal"})
                    : formik?.values?.allData?.[0]?.charge?.amount
                    ? numberFormat({number:(+sumOfSplittedAmount), decimal:2, style: "decimal"})
                    : formik?.values?.values?.[0]?.split_amount
                    ? numberFormat({number:(+formik?.values?.values?.[0]?.split_amount), decimal:2, style: "decimal"})
                    : formik?.values?.actual_total
                    ? numberFormat({number:(+formik.values?.actual_total), decimal:2, style: "decimal"})
                    : formik.values?.current_total
                    ? numberFormat({number:(+formik.values?.current_total), decimal:2, style: "decimal"})
                    : formik.values?.current_amount
                    ? numberFormat({number:(+formik.values?.current_amount), decimal:2, style: "decimal"})
                    : formik.values?.values?.[0]?.split_amount
                    ? numberFormat({number:(+formik.values?.values?.[0]?.split_amount), decimal:2, style: "decimal"})
                    : numberFormat({number:(+formik.values?.values?.[0]?.total_amount), decimal:2, style: "decimal"})
                      ?? numberFormat({number:(+sumOfAmounts), decimal:2, style: "decimal"})}
                </span>
              </div>
            </div>
            {(() => {
              const totalPaid =
                (+formik?.values?.creditCardAmount || 0) +
                (+formik?.values?.ach || 0) +
                (+formik?.values?.cash_payment || 0) +
                (+formik?.values?.onAccountCredit_payment || 0) +
                (formik?.values?.checks?.reduce((s, c) => s + (+c?.amount || 0), 0) || 0) +
                Object.entries(formik?.values || {})
                  .filter(([key, val]) => key.endsWith("_payment") && !["cash_payment", "onAccountCredit_payment", "ach_payment"].includes(key) && typeof val === "number" && !key.includes("credit") && !key.includes("ach") && !key.includes("cash"))
                  .reduce((sum, [, val]) => sum + (+val || 0), 0);
              return totalPaid > (+calculateTotalAmount() || 0);
            })() && (
              <div style={{ color: "#e53e3e", fontSize: 12, fontFamily: fontConfig.FinancePaymentInformationTextFont.family, fontWeight: 500, marginTop: 6 }}>
                Payment exceeds {formik?.values?.allData?.length > 1 ? "charges" : "charge"} amount
              </div>
            )}
            <div className="payment-info-divider" />
            <div className="payment-info-total-row payment-info-fee-row">
              <div className="payment-info-fee-label">Convenience Fee</div>
              <div className="payment-info-fee-value">
                {currency}{parseFloat(calculateConvenienceFeeAmount() ?? 0).toFixed(2)}
              </div>
            </div>
            <div className="payment-info-divider" />
            <div className="payment-info-total-row payment-info-fee-row">
              <div className="payment-info-fee-label">Payment Date</div>
              <div className="payment-info-fee-value payment-date">
                <DatePicker
                  isClearable={false}
                  showIcon
                  popperPlacement="top"
                  popperProps={{ strategy: "fixed" }}
                  popperClassName="payment-date-popper"
                  popperContainer={({ children }) => createPortal(children, document.body)}
                  placeholderText={placeholderFormat}
                  dateFormat={dateFormate}
                  selected={
                    formik?.values?.paymentDate &&
                      convertUTCToLocalDate(formik?.values?.paymentDate)
                  }
                  onChange={(e) => {
                    if (!e) {
                      formik.setFieldValue(`paymentDate`, new Date(formik.values.paymentDate || Date.now()));
                      return;
                    }
                    formik.setFieldValue(`paymentDate`, e);
                    convertLocalToUTCDate(e, `paymentDate`);
                  }}
                  maxDate={new Date()}
                  customInput={
                    <MaskedInput
                      pipe={autoCorrectedDatePipe}
                      mask={dateTimeMask}
                      keepCharPositions={true}
                      guide={true}
                    />
                  }
                  disabled={disabledPaymentDate()}
                />
              </div>
            </div>
          </div>
          <div className="party-payment py-10">
            <MyCheckbox
              name={"third_party"}
              title="3rd Party Payment"
              handlechange={(event) => {
                formik.setFieldValue("is_third_party", event.target.checked);
              }}
              checked={formik.values?.is_third_party}
            />
            {formik.values?.is_third_party && (
              <div className="pt-5">
                <div className="px-0 party-payment-icon w-100">
                  <Select
                    {...{
                      formik,
                      name: `third_party`,
                      checkValidation: false,
                    }}
                    onInputChange={(text) => searchAction(text)}
                    classNamePrefix="react-select"
                    formatOptionLabel={formatOptionLabel}
                    options={data}
                    isLoading={loading}
                    styles={colourStyles}
                    onChange={(value) => {
                      formik.setFieldValue(`third_party`, {
                        id: value._id,
                        name: value.label,
                      });
                    }}
                    value={
                      formik.values?.third_party
                        ? {
                            label: formik.values?.third_party?.name,
                            value: formik.values?.third_party?.id,
                          }
                        : ""
                    }
                    components={{ DropdownIndicator }}
                  />
                </div>
                <div
                  className="create-new-account"
                  style={createNewAccount ? { opacity: 0.3 } : {}}
                >
                  <span
                    className="new-add-icon"
                    onClick={() => setCreateNewAccount(true)}
                  >
                    <svg
                      width="50"
                      height="50"
                      viewBox="0 0 50 50"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15 25H35"
                        stroke="#2555EF"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M25 15V35"
                        stroke="#2555EF"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                  <span
                    className="add"
                    onClick={openCreateNewAccount}
                  >
                    Create New Account
                  </span>
                </div>
              </div>
            )}
          </div>
        </div>
        )}

      </div>{/* end payment-step2-layout */}
      <MyModal
        className="invite-modal"
        open={createNewAccountModal}
        onClose={closeCreateNewAccount}
      >
        <AddNewAccount
          setOpen={setCreateNewAccountModal}
          refresh={refresh}
          setRefresh={setRefresh}
          // closeModal={closeCreateNewAccount}
        />
      </MyModal>
      <AlertDialog
        open={confirmClose}
        onDecline={() => {
          setConfirmClose(false);
        }}
        onAccept={confirmCloseHandler}
        title={"Are you sure?"}
        description={"Do you want to discard the changes you made?"}
      />
    </div>
  );
};

export default PaymentInformation;
